/**
 * Created by rudi on 07/02/14.
 */

OLIVIO.NestedSVG = function (draw, rawSVG, index, callBack, options) {

  var self = this;
  this.rotation = 0;
  this.rcx = 0;
  this.rcy = 0;
  this.textRotation = 0;
  this.txtcx = 0;
  this.txtcy = 0;
  this.nindex = index;
  this.draw = draw;
  this.svg = draw.nested();
  this.svg.svg(rawSVG);
  this.down = false;
  this.group = draw.group();
  this.group.add(this.svg);
  this.textValue = "";
  this.selected = false;

  this.debugInlay = false;

  // colors
  var colorFill = '#ffffff';
  var colorOutline = '#000000';
  var colorFillInlay = '#ffffff';

  var colorFillSelected = '#000000';
  var colorOutlineSelected = '#ffffff';
  var colorFillInlaySelected = '#000000';

  this.setColor = function (nuColorFill, nuColorOutline, nuColorFillInlay, nuColorFillSelected, nuColorOutlineSelected, nuColorFillInlaySelected) {
    if (colorFill !== nuColorFill || colorOutline !== nuColorOutline || colorFillInlay !== nuColorFillInlay || colorFillSelected !== nuColorFillSelected || colorOutlineSelected !== nuColorOutlineSelected || colorFillInlaySelected !== nuColorFillInlaySelected) {
      colorFill = nuColorFill;
      colorOutline = nuColorOutline;
      colorFillInlay = nuColorFillInlay;
      colorFillSelected = nuColorFillSelected;
      colorOutlineSelected = nuColorOutlineSelected;
      colorFillInlaySelected = nuColorFillInlaySelected;

      this.repaint();
      return true;
    }
    return false;
  };


  this.circleSelectable = true;
  this.textStaysBlack = false;

  // used by poleside to sort displaylist
  this.displaySort = 0;

  //console.log(this.svg.bbox());
  //console.log(this.svg.viewbox());

  this.gX = this.svg.bbox().x;
  this.gY = this.svg.bbox().y;

  this.gW = this.svg.bbox().width;
  this.gH = this.svg.bbox().height;

  //console.log(this.svg.bbox());

  if (typeof options !== 'undefined') {
    //console.log('angular will get a mastheight update');
    this.gX = options.clickx;
    this.gY = options.clicky;

    this.gW = options.clickwidth;
    this.gH = options.clickheight;
  }

  // remove helper rectangle
  //this.svg.each(function(i, children) {
  this.svg.each(function () {
    try {
      //console.log(this.node.children[0].getAttribute("opacity"));
      if (this.node.children[0].getAttribute('opacity') === '0') {
        this.node.remove(this.node.children[0]);
        //this.fill({ color: '#ffffff' });
        //console.log('removed helper rectangle');
      }

    } catch (e) {
      //console.log('oi weh');
    }
  }, true);

  this.textGroup = this.draw.group();
  this.text = OLIVIO.getSVGText(this.draw, '');
  this.circle = draw.circle(80);
  this.circle.fill({color: '#ffffff'}).stroke({color: '#000000', width: 4});
  this.text.fill({color: '#000000'});
  this.textGroup.add(this.circle);
  this.textGroup.add(this.text);
  this.text.move(19.5, -5);
  this.circle.back();
  this.textGroup.hide();

  this.group.add(this.textGroup);

  this.clickArea = draw.rect(this.gW, this.gH).move(this.gX, this.gY);
  //this.clickArea.node.id = this.nindex;

  //console.log(this.clickArea.node.id);
  //this.clickArea.name = this.cid;
  /*this.clickArea.fill({ color: { r: (0.0) , g: (0.0), b: (0.0)
   }, opacity: (this.isMast?0.0:0.0) });*/
  this.clickArea.fill({color: '#ff44a0', opacity: (OLIVIO.debug ? 0.1 : 0.0)});
  this.group.add(this.clickArea);

  var down = function (e) {
    //if( navigator.userAgent.match(/Android/i) ) {
    //   e.preventDefault();
    //}
    callBack(e, self.nindex);
    //console.log(self.svg.bbox());
  };

  this.setText = function (text) {
    this.textValue = text;
    self.textGroup.show();
    self.text.text(text);
    //self.text.fill({ color: '#ff44a0', opacity: 1.0 });
    //self.text.move(x,y);
    //self.textGroup.back();
  };

  this.centerX = function () {
    return this.svg.bbox().x + this.svg.bbox().width * 0.5 + this.group.trans.x;
  };

  this.centerY = function () {
    return this.svg.bbox().y + this.svg.bbox().height * 0.5 + this.group.trans.y;
  };

  if (callBack) {
    NeoUtils.addDownHandler(this.clickArea.node, down);
    this.clickArea.node.style.cursor = 'pointer';
  }

  this.unBindHandlers = function () {
    if (callBack) {
      NeoUtils.removeDownMoveUpHandlers(this.clickArea.node, down);
    }
  };

  this.setSelected = function (value) {
    // i, children
    this.selected = value;
    this.repaint();
  };

  this.repaint = function() {
    var value = this.selected;
    this.svg.each(function () {
      if (this.node.id === 'inlay' || this.node.id === 'inlayhole') {
        this.fill({color: (value ? colorFillInlaySelected : colorFillInlay)});
        this.stroke({color: (value ? colorOutlineSelected : colorOutline)});
      } else {
        this.fill({color: (value ? colorFillSelected : colorFill)});
        this.stroke({color: (value ? colorOutlineSelected : colorOutline)});
      }
    }, true);

    var unselectedtextcolor = this.textStaysBlack ? '#000000' : (colorOutline === '#ffffff' ? '#cccccc' : colorOutline);

    if (this.circleSelectable) {
      if (value === true) {
        this.circle.fill({color: '#000000'}).stroke({color: '#000000', width: 4});
        this.text.fill({color: '#cccccc'});
      } else {
        this.circle.fill({color: '#ffffff'}).stroke({color: '#000000', width: 4});
        this.text.fill({color: unselectedtextcolor});
      }
    } else {
      this.circle.fill({color: '#ffffff'}).stroke({color: '#000000', width: 4});
      this.text.fill({color: unselectedtextcolor});
    }
  };

  this.setCursorStyle = function (value) {
    this.clickArea.node.style.cursor = value;
  };

  this.setWhiteStrokes = function () {
    this.svg.each(function () {
      this.fill({ color: '#ff44a0', opacity: 0.0 });
      this.stroke({ color: '#ffffff' });
    }, true);
  };

  this.rotate = function (value,cx,cy) {
    this.rotation = value;
    this.rcx = cx;
    this.rcy = cy;
    this.group.rotate(value,cx,cy);
  };

  this.rotateText = function (value,cx,cy) {
    this.textRotation = value;
    this.txtcx = cx;
    this.txtcy = cy;
    this.textGroup.rotate(value,cx,cy);
  };

  this.rotateNestedLikeThis = function (nested) {
    nested.rotate(this.rotation,this.rcx,this.rcy);
  };

  this.rotateTextLikeThisText = function (textGroup) {
    textGroup.rotate(this.textRotation,this.txtcx,this.txtcy);
  };

  this.scale = function (x, y, animated) {
    var yOffset = (this.gH - this.gY) - this.gH * y;
    //console.log(this.gH+' '+this.gY+' '+yOffset);
    if (animated === true) {
      this.group.animate().scale(x, y).move(this.gX, this.gY + yOffset);
    } else {
      this.group.scale(x, y).move(this.gX, this.gY + yOffset);
    }
  };

  this.updateSVGraw = function (rawSVG) {
    //this.svg.remove();
    this.svg.clear();
    this.svg.svg(rawSVG);
    //this.group.add(this.svg);
  };

  // bla

  /*

   this.updateSVGByPoolIndex = function(index) {
   //this.svg.remove();
   this.setSelected(false);
   this.svg.hide();
   this.svg = self.svgPool[index];
   this.svg.show();
   };

   this.setSVGPool = function (rawpool) {
   self.svgPool = [];
   this.svg.clear();
   for (var i=0;i<rawpool.length;i++) {
   var svg = draw.nested();
   svg.svg(rawpool[i]);
   this.group.add(svg);
   svg.back();
   svg.hide();
   this.svgPool.push(svg);
   }

   };
   */

};
